import React from "react";
import { useTranslation } from "react-i18next";

import Button from "../../../../components/Button";
import Modal from "../../../../components/v2/Modal";

import style from "./styles.module.scss";

const keyI18n = "translations.admin.notices.confirm";

export type ConfirmAction = "publish" | "unpublish" | "remove";

const icons: { [key in ConfirmAction]: string } = {
  publish: "publish",
  unpublish: "unpublished",
  remove: "delete",
};

interface Props {
  action: ConfirmAction | null;
  title: string;
  busy: boolean;
  error: string | null;
  onCancel(): void;
  onConfirm(): void;
}

export default function ConfirmDialog({ action, title, busy, error, onCancel, onConfirm }: Props) {
  const { t } = useTranslation();

  if (!action) {
    return null;
  }

  return (
    <Modal
      open
      onClose={busy ? () => undefined : onCancel}
      dismissible={!busy}
      icon={icons[action]}
      title={t(`${keyI18n}.${action}.title`, { title })}
      size="small"
      actions={(
        <>
          <Button variant="text" size="small" onClick={onCancel} disabled={busy}>
            {t(`${keyI18n}.cancel`)}
          </Button>
          <Button variant="filled" size="small" onClick={onConfirm} disabled={busy} softDisabled={busy}>
            {t(`${keyI18n}.${action}.confirm`)}
          </Button>
        </>
      )}
    >
      <p className="pgm-body-medium">{t(`${keyI18n}.${action}.description`)}</p>
      {error && (
        <p className={`pgm-body-medium ${style.formError}`} role="alert">
          {error}
        </p>
      )}
    </Modal>
  );
}
